import { AppPageHeader, DatePicker } from '@/components/_common';
import UsersInfiniteSelectField from '@/components/_common/UsersInfiniteSelectField';
import {
  MailHistoryFilterInterface,
  mailType,
} from '@/core/domain/mail/MailHistory/MailHistory.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Col, Input, Row, Select } from 'antd';
import moment from 'moment';

export default function EmailHistoryFilter({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<MailHistoryFilterInterface>) {
  const emailTypes = Object.keys(mailType)
    .sort((a, b) => (mailType[a] > mailType[b] ? 1 : -1))
    .map((key) => ({
      value: key,
      label: mailType[key],
    }));

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({
          ...prev,
          subject: value,
        }))
      }
      searchValue={queryParams?.from}
      extraFilters={
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={5}>
            <Select
              style={{ width: '100%' }}
              placeholder="Selecione um tipo de e-mail"
              showSearch
              optionFilterProp="label"
              allowClear
              options={emailTypes}
              onChange={(value) =>
                setQueryParams((params) => ({ ...params, mailType: value }))
              }
            />
          </Col>

          <Col xs={24} sm={12} lg={9} xl={10}>
            <UsersInfiniteSelectField
              mode="multiple"
              maxTagCount="responsive"
              placeholder="De"
              onChange={(value) =>
                setQueryParams((params) => ({
                  ...params,
                  usersId: value?.toString(),
                }))
              }
            />
          </Col>

          <Col xs={24} sm={12} lg={7} xl={4}>
            <Input
              placeholder="Para"
              onChange={({ target }) =>
                setQueryParams((params) => ({ ...params, to: target.value }))
              }
            />
          </Col>

          <Col xs={24} sm={12} lg={6} xl={4}>
            <DatePicker
              placeholder="Data de envio"
              onChange={(value) =>
                setQueryParams((params) => ({
                  ...params,
                  sentDate: value
                    ? moment(value).format('YYYY-MM-DD')
                    : undefined,
                }))
              }
            />
          </Col>
        </Row>
      }
    />
  );
}
